export const ToastrTypes = {
    SHOW: "./toast/SHOW",
    HIDE: "./toast/HIDE",
}